"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LanguageSettingsWidget = function LanguageSettingsWidget(_ref) {
  var lang = _ref.lang,
      supportedLanguages = _ref.supportedLanguages,
      _ref$onLangChange = _ref.onLangChange,
      onLangChange = _ref$onLangChange === void 0 ? function () {} : _ref$onLangChange,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      t = _ref.translator;
  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Language settings')
  }, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t('Select your preferred language'),
    titlePadding: 10,
    backgroundColor: "white"
  }, Object.keys(supportedLanguages).map(function (langKey) {
    return /*#__PURE__*/_react["default"].createElement(_Element["default"], {
      onClick: function onClick() {
        onLangChange(langKey);
        onBack();
      },
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: lang === langKey ? 'check' : 'circle outline',
      style: {
        visibility: 'visible',
        // lang === langKey ? 'visible' : 'hidden',
        color: lang === langKey ? _Colors.primaryColor : _Colors.widgetBorderColor,
        display: 'inline',
        marginRight: 15,
        marginBottom: 2
      }
    }), /*#__PURE__*/_react["default"].createElement("span", null, supportedLanguages[langKey]));
  })));
};

var _default = LanguageSettingsWidget;
exports["default"] = _default;